<div class="container">
  <app-heading
    icon="devices"
    title="Geräte Einstellungen"
    i18n-title
  ></app-heading>

  <div class="body">
    <mat-card class="audio-video-settings">
      <app-card-header-with-action
        i18n-title
        title="Video- & Audiogeräte"
        i18n-subTitle
        subTitle="Konfigurieren und testen Sie Ihre Geräte"
        [actionEnabled]="false"
      ></app-card-header-with-action>
      <mat-card-content class="audio-video-settings-content">
        <app-media-settings
          (settingsChanged)="onSettingsChanged($event)"
        ></app-media-settings>
        <app-virtual-background-settings></app-virtual-background-settings>
      </mat-card-content>
    </mat-card>
  </div>
</div>
